import CrudCustom from '../../../libs/custom/CrudCustom';

let ReturPenjualanAkunService = new CrudCustom('/pos-transaksi-retur-penjualans');
export default ReturPenjualanAkunService;
